export default "__VITE_PUBLIC_ASSET__b3f6b932__"